export default [
    {
        path: '/mail-settings/payment-types-footer',
        name: 'mail_settings_payment_types_footer',
        component: () => import('@src/mail-settings/payment-types-in-footer-settings.vue'),
        meta: {
            title: 'Zahlarten im Footer',
            role: 'ROLE_EDIT_MAIL_SETTINGS',
        },
    },
];
